import * as React from "react";
import { connect } from "react-redux";
import * as types from "../../../../../constants/actionTypes";
import { logUI } from "../../../../../api/andyliticsApi";
import * as Tools from "../../../../../helpers/Tools";
import { Typography, Grid, TextFieldWithValidation as TextField, DropDownWithValidation as DropDown, PhoneNumberWithValidation as PhoneNumber } from "../../../../ecosystem/";
import { CareGapsButtons, CareGapsHeading } from '../../components';
import CareGapsConfirmationModal from "../../CareGapsConfirmationModal";
import * as procedureType from "../../../../../constants/textConstants";

class AnnualWellnessVisitUpdateHistory extends React.Component {
    constructor(props) {
        super(props);
        const { careGapFlowFormInputs } = this.props;
        this.state = {
            user: {
                name: careGapFlowFormInputs && careGapFlowFormInputs.name || '',
                pNumber: careGapFlowFormInputs && careGapFlowFormInputs.pNumber || '',
                faxNumber: careGapFlowFormInputs && careGapFlowFormInputs.faxNumber || '',
                city: careGapFlowFormInputs && careGapFlowFormInputs.city || '',
                state: careGapFlowFormInputs && careGapFlowFormInputs.state || '',
                pMonth: careGapFlowFormInputs && careGapFlowFormInputs.pMonth || '', //monthNumber,
                pYear: careGapFlowFormInputs && careGapFlowFormInputs.pYear || '', //currentYear,
            },
            nameValid: false,
            pNumberValid: false,
            pMonthValid: false,
            pYearValid: false,
            formValid: false,
        };
    }

    componentDidMount() {
        const { careGapsSessionId } = this.props;
        logUI("MBHWeb.UI.AnnualWellnessVisitUpdateHistory.ComponentDidMount", new Date(), Tools.getURLPath(), careGapsSessionId && { careGapsSessionId: careGapsSessionId });
        this.populatePreCheckedProxySelect();
    }

    populatePreCheckedProxySelect = () => {
        const { careGapFlowFormInputs } = this.props;
        if (careGapFlowFormInputs) {
             this.setState({
                user: {
                     name: careGapFlowFormInputs.name,
                     pNumber: careGapFlowFormInputs.pNumber,
                     city: careGapFlowFormInputs.city,
                     faxNumber: careGapFlowFormInputs.faxNumber,
                     pMonth: careGapFlowFormInputs.pMonth,
                     pYear: careGapFlowFormInputs.pYear,
                     state: careGapFlowFormInputs.state,
                },
                
            })
        }
        this.validateForm();
    }
    handleClickNext = (event) => {
        const { updateCareGapFlowFormInputs, history, careGapFlowFormInputs, careGapsSessionId } = this.props;
        history.push('/schedulemyAnnualWellnessVisit/confirmhistory');
        logUI(`MBHWeb.UI.AnnualWellnessVisitUpdateHistory.Next.Clicked`, new Date(), Tools.getURLPath(), careGapsSessionId && { careGapsSessionId: careGapsSessionId });
        let formData = this.state.user;
        careGapFlowFormInputs ? formData.attachments = careGapFlowFormInputs?.attachments : formData
        updateCareGapFlowFormInputs(formData, procedureType.AWF)
    }

    handleClickPrev = () => {
        const { updateCareGapFlowFormInputs, careGapsSessionId } = this.props;
        logUI(`MBHWeb.UI.AnnualWellnessVisitUpdateHistory.Previous.Clicked`, new Date(), Tools.getURLPath(), careGapsSessionId && { careGapsSessionId: careGapsSessionId });
        this.props.history.push('/schedulemyAnnualWellnessVisit');
        updateCareGapFlowFormInputs(this.state.user, procedureType.AWF)
    }

    handleUserInput(fieldName, value) {
        this.setState({
            user: {
                ...this.state.user,
                [fieldName]: value
            },
            [fieldName]: value,
        }, () => { this.validateField(fieldName, value) });
    }

    validateField(fieldName, value) {
        let nameValid = this.state.nameValid;
        let pNumberValid = this.state.pNumberValid;
        let pMonthValid = this.state.pMonthValid;
        let pYearValid = this.state.pYearValid;

        switch (fieldName) {
            case 'name':
                nameValid = value.match(/^[A-Za-z][A-Za-z\'\-]+([\ A-Za-z][A-Za-z\'\-]+)*/);
                break;
            case 'pNumber':
                pNumberValid = value.match(/^(?!(\d)\(\1{3}\))(?!(\d)\2{9})(?!(\d)\3{2}.\3{3}.\3{4})(?:\(^[2-9]\d{2}\)|^[2-9]\d{2})(.?)?\d{3}\4\d{4}$/);
                break;
            case 'pMonth':
                pMonthValid = value && value !== null ? true : false;
                break;
            case 'pYear':
                pYearValid = value && value !== null ? true : false;
                break;
            default:
                break;
        }
        this.setState({
            nameValid: nameValid,
            pNumberValid: pNumberValid,
            pMonthValid: pMonthValid,
            pYearValid: pYearValid,
        }, this.validateForm);
    }

    validateForm() {
        const { nameValid, pMonthValid, pYearValid, pNumberValid, user } = this.state;
        this.setState({
            formValid: (nameValid || user.name) && (pNumberValid || user.pNumber) && (pMonthValid || user.pMonth) && (pYearValid || user.pYear) 
        });
    }


    render() {
        const { user, formValid} = this.state;
        const subHeading = "Provide as much information as you can about your annual wellness visit, and we will take care of the rest.";
        return (
            <Grid fluid className="body-content body-content--no-top-offset care-gaps-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <CareGapsHeading
                            heading="Update your history"
                            description={subHeading}
                        />

                        <div className="row care-gaps-form-heading">
                            <div className="col-12">
                                <Typography
                                    color={"$color-primary-a2"}
                                    type="heading-01"
                                    responsive
                                >
                                    Date of annual wellness visit
                                </Typography>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 col-xl-9">
                                <div className="row">
                                    <div className="col-12" >
                                        <div className="row">
                                            <div className="col-12 col-lg-6" >
                                                <DropDown
                                                    label="Choose month"
                                                    options={Tools.getMonths()}
                                                    id="pMonth"
                                                    name="pMonth"
                                                    onChange={(e) => { this.handleUserInput('pMonth', e.target.value); }}
                                                    value={user.pMonth}
                                                    required
                                                    errorMsg="Select a valid month"
                                                />
                                            </div>
                                            <div className="col-12 col-lg-6">
                                                <DropDown
                                                    label="Choose year"
                                                    id="pYear"
                                                    name="pYear"
                                                    options={Tools.getYears()}
                                                    onChange={(e) => { this.handleUserInput('pYear', e.target.value); }}
                                                    value={user.pYear}
                                                    required
                                                    errorMsg="Select a valid year"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row care-gaps-form-heading">
                            <div className="col-12">
                                <Typography
                                    color={"$color-primary-a2"}
                                    type="heading-01"
                                    responsive
                                >
                                    Facility
                                </Typography>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 col-xl-9">
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <TextField
                                            label="Name of facility"
                                            id="name"
                                            name="name"
                                            value={user.name || ''}
                                            errorMsg="Enter a valid name"
                                            onChange={(e) => { this.handleUserInput('name', e.target.value); }}
                                            required
                                        />
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <PhoneNumber
                                            label="Phone number"
                                            id="pNumber"
                                            name="pNumber"
                                            required
                                            value={user.pNumber || ''}
                                            onChange={(e) => { this.handleUserInput('pNumber', e.target.value); }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-6 col-lg-3">
                                        <TextField
                                            label="City"
                                            id="city"
                                            name="city"
                                            value={user.city || ''}
                                            errorMsg="Enter a valid city"
                                            onChange={(e) => { this.handleUserInput('city', e.target.value); }}
                                        />
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-3">
                                        <DropDown
                                            label="State"
                                            id="state"
                                            name="state"
                                            options={Tools.getStates()}
                                            onChange={(e) => { this.handleUserInput('state', e.target.value); }}
                                            value={user.state || ''}
                                        />
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <PhoneNumber
                                            label="Fax number"
                                            name="faxNumber"
                                            value={user.faxNumber || ''}
                                            onChange={(e) => { this.handleUserInput('faxNumber', e.target.value); }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <CareGapsButtons
                            prev={{
                                onClick: () => this.handleClickPrev()
                            }}
                            next={{
                                disabled: !formValid,
                                onClick: () => this.handleClickNext()
                            }}
                        />
                    </div>
                </div>
                <CareGapsConfirmationModal careGapsType="schedulemyAnnualWellnessVisit" />
            </Grid>
        );
    }

};

const mapStateToProps = (state) => {
    return {
        history: state.session.history,
        careGapFlowFormInputs: state.careGap.careGapFlowFormInputs,
        careGapsSessionId: state.careGap.careGapsSessionId
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        updateCareGapFlowFormInputs: (formInputs, procedureType) => dispatch({ type: types.UPDATE_CAREGAP_FLOW_FORM_INPUTS, formInputs, procedureType })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AnnualWellnessVisitUpdateHistory);
